import TabSwitcherWeb from "@components/switcher/TabSwitcherWeb";
import { isPaysonicHost } from "src/config/deploymentConfig";
import KybTable from "../kyb/KybLinks";
import KycApprovalList from "./KycApprovalList";

const KycTabs = () => {
  const isPaysonic = isPaysonicHost();

  const kycTabs = isPaysonic
    ? [
        {
          label: "KYC",
          component: <KycApprovalList />,
        },
      ]
    : [
        {
          label: "KYC",
          component: <KycApprovalList />,
        },
        {
          label: "KYB",
          component: <KybTable />,
        },
      ];

  return (
    <div className="flex flex-col h-full">
      <div className="h-[70px] border-b border-border-subtle bg-bg-page-body flex flex-row sticky top-0 bg-white z-10 pl-[20px]">
        <div className="flex flex-row justify-between items-center w-full mr-4">
          <p className="text-text-base text-[14px] font-semibold">KYC</p>
        </div>
      </div>
      <div className="mx-4 mt-4 flex min-h-0 flex-1 flex-col overflow-hidden">
        <TabSwitcherWeb tabs={kycTabs} full={true} />
      </div>
    </div>
  );
};

export default KycTabs;
